import { useMemo } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ActionsCell } from '@/components/Workspace.Files.Table/Files.Table.Cells.Action';
import Cells from '../Files.Table.Cells';
import { useSelectObjectsEnabled } from './useSelectObjectsEnabled';

export const useFilesTableColumns = () => {
  const isDesktop = useMediaQuery('(min-width:900px)');
  const selectObjectsEnabled = useSelectObjectsEnabled();

  return useMemo(
    () =>
      [
        selectObjectsEnabled
          ? {
              accessor: 'checkbox',
              id: 'checkbox',
              Header: Cells.CheckboxHeader,
              Cell: Cells.Checkbox,
              width: 40,
              disableSortBy: true,
            }
          : null,
        {
          accessor: 'name',
          id: 'name',
          Header: 'Name',
          Cell: Cells.Name,
          minWidth: 300,
        },
        // {
        //   accessor: 'publishedStatus',
        //   id: 'publishedStatus',
        //   Header: 'Publish Status',
        //   Cell: Cells.PublishedStatus,
        //   minWidth: 90,
        //   maxWidth: 90,
        //   disableSortBy: true,
        // },
        {
          accessor: 'tags',
          id: 'tags',
          Header: 'Tags',
          Cell: Cells.Tags,
          minWidth: 250,
        },
        {
          accessor: 'bookmark',
          id: 'bookmark',
          Header: 'Pinned',
          Cell: Cells.Bookmark,
          minWidth: 60,
          maxWidth: 60,
        },
        isDesktop
          ? {
              accessor: 'owner',
              id: 'owner',
              Header: 'Owner',
              Cell: Cells.Owner,
              width: 80,
            }
          : undefined,
        isDesktop
          ? {
              accessor: 'createdOn',
              id: 'createdOn',
              Header: 'Created On',
              Cell: Cells.CreatedOn,
              minWidth: 80,
              width: 80,
            }
          : undefined,
        {
          id: 'actions',
          Cell: ActionsCell,
          minWidth: 50,
          width: 50,
          disableSortBy: true,
        },
      ].filter(Boolean),
    [isDesktop, selectObjectsEnabled]
  );
};
